import { Box, Text } from '@wix/design-system';
import type { FunctionComponent } from 'react';
import React, { useContext } from 'react';

import { RicosContext } from './../../ricos-context';

export const GiphyEmptyState: FunctionComponent<{
  category: 'gifs' | 'stickers';
}> = ({ category }) => {
  const { t } = useContext(RicosContext);
  return (
    <Box
      height="100%"
      alignContent="center"
      display="grid"
      textAlign="center"
      fontSize="14px"
      letterSpacing="1px"
      gap="12px"
    >
      <Text size="medium" weight="bold">
        {category === 'gifs'
          ? t('GiphyPlugin_Search_EmptyState_Title')
          : t('GiphyPlugin_Search_EmptyState_Title_Stickers')}
      </Text>
      <Text size="small" weight="thin">
        {t('GiphyPlugin_Search_EmptyState_Text')}
      </Text>
    </Box>
  );
};
